require('../modules/web.dom-collections.iterator');
require('../modules/es.string.iterator');
var getIterator = require('../internals/get-iterator');

module.exports = getIterator;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/get-iterator.js
// module id = 1012
// module chunks = 0